import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from 'app/guards/account.service';
import { Contract } from 'app/models/contract.model';
import { LoginRequestModel } from 'app/models/login-result.model';
import { SessionLog } from 'app/models/session-log.model';
import { User } from 'app/models/user.model';
import { ContractService } from 'app/services/contract.service';
import { DateConvertService } from 'app/services/date-convert.service';
import { LogsService } from 'app/services/logs.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class LoginComponent implements OnInit {
    public admin: number;
    public imei:string;
    public tableLoading = false;
    public session = new SessionLog;
    private _loginRequestModel: LoginRequestModel = new LoginRequestModel();
    public get model(): LoginRequestModel {
        return this._loginRequestModel;
    }
    public set model(v: LoginRequestModel) {
        this._loginRequestModel = v;
    }

    constructor(
        private _accountService: AccountService,
        private _toastService: ToasterService,
        private _router: Router,
        private http: HttpClient,
        private route: ActivatedRoute,
        private _logServeice: LogsService,
        private _contractService: ContractService,
        private _dateConvertService: DateConvertService,
        private _translateService:TranslateService
    ) {
        this.route.queryParams.subscribe(params => {
            debugger;
        this.imei = params.imei;
      }
    );
    }

    async ngOnInit(): Promise<void> {
        if (this._accountService.isAuthenticated) {
            this.RoutingControl();
        }
    }


    public async login() {
        this.tableLoading=true;
        try {
            let response = await this._accountService.login(this._loginRequestModel);
            if (response.result == "OK") {
                if(this.imei){
                    localStorage.setItem("IMEI",this.imei);
                }
                this.tableLoading=false;
            
                if(parseInt(localStorage.getItem("Active"))==0){
                    this._toastService.toastFail();
                    this._accountService.logout();
                    return false;
                }
            }
        } catch (error) {
            this._toastService.toastFail();
            this.tableLoading=false;
            return false;
        }


        var contract: Array<Contract>;
        try {
            contract = await this._contractService.getContracts(parseInt(localStorage.getItem("CompanyID")));
        } catch (error) {
            console.warn(error);
        }

        var date = new Date;
        if (localStorage.getItem("Contract") == "false" && parseInt(localStorage.getItem("CompanyID"))!=1) {
            this._toastService.toastFail(this._translateService.instant("INVALID_CONTRACT"))
            localStorage.clear();
            return false;
        }
        this.RoutingControl();
        await this.getBrowserDate();
        var session = await this._logServeice.setSession(this.session);
        localStorage.setItem('SessionLogId',session.id.toString());
    }
    public async RoutingControl() {
        var route = "/"
        
        this.admin = parseInt(localStorage.getItem("RoleID"))

        route = this.admin == 1 ? "/apps/driver-map" : "/";
        
        this._router.navigate([route]).then(() => {
           // window.location.reload();
        });
    }
    public async getBrowserDate() {
        var userAgent = navigator.userAgent, tem,
            matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        this.session.browserName = matchTest[1]
        this.session.userAgent = userAgent;
        this.session.browserVersion = matchTest[2]
        this.session.date = new Date;
        this.session.username = localStorage.getItem("Username");
        this.session.userId = parseInt(localStorage.getItem("UserID"));
        this.session.companyId = parseInt(localStorage.getItem("CompanyID"))
    }

}
